var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYoutube = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.6562 9.90625C22.0312 11.2188 22.0312 14.0312 22.0312 14.0312C22.0312 14.0312 22.0312 16.8125 21.6562 18.1562C21.4688 18.9062 20.875 19.4688 20.1562 19.6562C18.8125 20 13.5 20 13.5 20C13.5 20 8.15625 20 6.8125 19.6562C6.09375 19.4688 5.5 18.9062 5.3125 18.1562C4.9375 16.8125 4.9375 14.0312 4.9375 14.0312C4.9375 14.0312 4.9375 11.2188 5.3125 9.90625C5.5 9.15625 6.09375 8.5625 6.8125 8.375C8.15625 8 13.5 8 13.5 8C13.5 8 18.8125 8 20.1562 8.375C20.875 8.5625 21.4688 9.15625 21.6562 9.90625ZM11.75 16.5625L16.1875 14.0312L11.75 11.5V16.5625Z",
  fill: "white"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 13,
  stroke: "white"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.43b0b64b.svg";
export { ForwardRef as ReactComponent };